<template>
  <a-layout class="faqs">
    <TitleBreadcrumb />
    <div class="content-base container">
      <FAQsComponent />
    </div>
  </a-layout>
</template>
<script>
import FAQsComponent from "@/components/FAQsComponent.vue";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import loadingMixin from "@/mixins/loadingMixin";
export default {
  components: { FAQsComponent, TitleBreadcrumb },
  name: "FAQsPage",
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.faqs {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}
</style>
